import React, { createContext, useContext } from 'react';

const RegionContext = createContext();

export const useRegion = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};

export const RegionProvider = ({ children }) => {
  const getCurrency = () => 'CAD';

  const getCurrencySymbol = () => 'CAD';

  const formatPrice = (priceCAD) => {
    return `CAD ${priceCAD.toLocaleString()}`;
  };

  const value = {
    getCurrency,
    getCurrencySymbol,
    formatPrice
  };

  return (
    <RegionContext.Provider value={value}>
      {children}
    </RegionContext.Provider>
  );
};
